/*
  Revelado al entrar en el viewport.

  Por qué no se hace con CSS: `animation-timeline: view()` solo existe en
  Chrome. En Safari y Firefox no se mueve nada, y el iPhone es justo por donde
  entra el tráfico de Instagram. Esto son 900 bytes y funciona en todo.

  Mejora progresiva: sin JavaScript el contenido se ve, porque el estado oculto
  cuelga de `html.js`, que pone el propio tema.
*/
(function () {
  'use strict';

  var SELECTOR = '.l-in';
  var VISIBLE = 'is-in';

  function mostrarTodo() {
    document.querySelectorAll(SELECTOR).forEach(function (el) {
      el.classList.add(VISIBLE);
    });
  }

  // Quien pide menos movimiento no recibe ninguno: aparece y ya está.
  var sinMovimiento = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (sinMovimiento.matches || !('IntersectionObserver' in window)) {
    document.addEventListener('DOMContentLoaded', mostrarTodo);
    return;
  }

  var observador = new IntersectionObserver(
    function (entradas) {
      entradas.forEach(function (entrada) {
        if (!entrada.isIntersecting) return;
        entrada.target.classList.add(VISIBLE);
        // Una sola vez: reaparecer al volver a subir marea y delata el truco.
        observador.unobserve(entrada.target);
      });
    },
    {
      // Umbral cero y margen inferior negativo: dispara en cuanto el borde
      // superior entra un poco. Con un porcentaje, un bloque alto no llega a
      // cumplirlo hasta haber scrolleado dentro, y hasta entonces ocupa sitio
      // sin verse. Eso deja un hueco enorme en mitad de la pagina.
      // El borde inferior sube un 15%: lo justo para que el movimiento no ocurra
      // pegado al pie, donde no se ve. Al 45% se esperaba tanto que quedaba media
      // pantalla en blanco y la seccion aparecia de golpe.
      rootMargin: '0px 0px -15% 0px',
      threshold: 0,
    }
  );

  function observar() {
    document.querySelectorAll(SELECTOR).forEach(function (el, i) {
      // Lo que ya está en pantalla al cargar no se anima: entra puesto.
      // Mismo criterio para lo que ya esta en pantalla al cargar.
      if (el.getBoundingClientRect().top < window.innerHeight * 0.85) {
        el.classList.add(VISIBLE);
        return;
      }
      observador.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observar);
  } else {
    observar();
  }

  // El editor de temas reinyecta secciones sin recargar la página.
  document.addEventListener('shopify:section:load', observar);
})();
